import { isObject } from 'lib';

const CAPACITY_INFO_KEYS = {
  instagram: ['instagram'],
  twitter: ['twitter'],
  telegram: ['telegram'],
};

export const normalizeVipList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.result?.data)) return payload.result.data;
  if (Array.isArray(payload?.results)) return payload.results;
  return [];
};

export const adaptVipResource = (item) => {
  const resource = isObject(item?.resource) ? item.resource : {};
  return {
    ...item,
    ...resource,
    vipId: item?.id,
    id: item?.resource_id ?? resource.id ?? item?.id,
    resource_id: item?.resource_id ?? resource.id,
    username: item?.username ?? resource.username ?? item?.screen_name,
    title: resource.title ?? item?.title ?? item?.name ?? item?.username,
    avatar: item?.avatar ?? resource.avatar ?? item?.profile_image,
    description: item?.description ?? resource.description,
  };
};

export const adaptVipResources = (items) =>
  (Array.isArray(items) ? items : []).map(adaptVipResource);

export const readVipCapacity = (info, platform) => {
  if (!isObject(info)) return undefined;
  const keys = CAPACITY_INFO_KEYS[platform] || [
    platform,
    platform?.toLowerCase(),
  ];
  const value = keys.map((key) => info[key]).find(isObject);
  if (!value) return undefined;
  const used = Number(value.vip_resource_used ?? value.vip_used);
  const allowed = Number(value.vip_resource_allowed ?? value.vip_allowed);
  if (!Number.isFinite(used) && !Number.isFinite(allowed)) return undefined;
  return {
    used: Number.isFinite(used) ? used : 0,
    allowed: Number.isFinite(allowed) ? allowed : 0,
  };
};

export const adaptVipCapacities = (info) => {
  if (!isObject(info)) return {};
  return Object.fromEntries(
    Object.keys(CAPACITY_INFO_KEYS).map((platform) => [
      platform,
      readVipCapacity(info, platform),
    ])
  );
};
